import { ReactComponent as DeviationDetectionIcon } from "assets/svgs/inspections/DeviationDetection.svg";

export const DeviationDetectionShowIcons = {
    false: <DeviationDetectionIcon className="w-6" />,
    true: <DeviationDetectionIcon className="w-6" />,
};
export const DefaultShowDeviationDetection = false;
